import {WikidataEntity} from "../Types/WikidataEntity.interface";

async function searchWikidata(id_wikidata: string): Promise<WikidataEntity | null> {
    const apiUrl = `https://www.wikidata.org/wiki/Special:EntityData/${encodeURIComponent(id_wikidata)}.json`;

    try {
        const response = await fetch(apiUrl);

        if (!response.ok) {
            throw new Error('Failed to fetch data from Wikidata.');
        }

        const data = await response.json();
        const entity = data.entities[id_wikidata] as WikidataEntity;
        return entity;
    } catch (error) {
        console.error('Error searching Wikidata:', error);
        return null;
    }
}

export { searchWikidata };
